import React, { useState, useEffect } from 'react';
import profile from '../data/profile';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-slate-900/90 backdrop-blur-md shadow-lg' 
        : 'bg-transparent'
    }`}>
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="text-2xl font-bold text-gradient">
            {profile.identity.fullName || 'Portfolio'}
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
            >
              À propos
            </button>
            <button 
              onClick={() => scrollToSection('skills')}
              className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
            >
              Compétences
            </button>
            <button 
              onClick={() => scrollToSection('projects')}
              className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
            >
              Projets
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
            >
              Contact
            </button>
            <a href={profile.assets.cvUrl || '#'} target="_blank" rel="noreferrer" className="bg-gradient-primary text-white px-6 py-2 rounded-full hover:shadow-lg transition-all duration-200 transform hover:scale-105">
              Télécharger CV
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-300"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-slate-800/95 backdrop-blur-md rounded-lg shadow-lg">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-300 hover:text-primary-400 transition-colors duration-200 px-4 py-2"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-300 hover:text-primary-400 transition-colors duration-200 px-4 py-2"
              >
                À propos
              </button>
              <button 
                onClick={() => scrollToSection('skills')}
                className="text-gray-300 hover:text-primary-400 transition-colors duration-200 px-4 py-2"
              >
                Compétences
              </button>
              <button 
                onClick={() => scrollToSection('projects')}
                className="text-gray-300 hover:text-primary-400 transition-colors duration-200 px-4 py-2"
              >
                Projets
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-300 hover:text-primary-400 transition-colors duration-200 px-4 py-2"
              >
                Contact
              </button>
              <a href={profile.assets.cvUrl || '#'} target="_blank" rel="noreferrer" className="bg-gradient-primary text-white px-6 py-2 rounded-full hover:shadow-lg transition-all duration-200 mx-4">
                Télécharger CV
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
